<div id="reno-bg">

</div>
<!--section parallax bg1-->
<div class="reno-cup-banner">
  <div class="overlay-layer-bottom"></div>

  <!--<div class="overlay-layer "></div>-->

  <div class="logo">
    <img src="assets/img/reno-cup/pubg-oppo-logo.png" alt="oppo-pubg-logo">
  </div>
  <div class="logo2">
    <img src="assets/img/reno-cup/reno5-logo.png" alt="">
  </div>

  <img src="assets/img/reno-cup/artwork.png" class="img-responsive artwork" style="position:absolute; bottom:0; right:0; max-width:550px;">

  <div class="container" style="height:100%;">

    <div class="flex_block column" style="height:100%;">

      <div class="content">

        <div class="l">
          <img src="assets/img/reno-cup/reno-cup-logo.png" class="hidden-lg hidden-md" alt="" width="300">
          <h1  class="hidden-xs hidden-sm">RENO CUP</h1>
          <h2  class="hidden-xs hidden-sm">Born To Win</h2>
          <p>Winning PUBG Mobile experience with Hyper Boost</p>
        </div>
      </div>

      <div class="partners">


        <div class="l">
          <img src="assets/img/reno-cup/pubg-copyrights-logo.png" width="350" alt="">
        </div>
<!--        <div class="r">-->
<!--          &lt;!&ndash;          <img src="assets/img/reno-cup/vl-logo.png" alt="">&ndash;&gt;-->
<!--          <img src="assets/img/reno-cup/gbarena-logo.svg" alt="">-->
<!--          &lt;!&ndash;          <img src="assets/img/reno-cup/orange-esports-logo.png" alt="">&ndash;&gt;-->
<!--        </div>-->
      </div>
    </div>

  </div>

</div>
<perfect-scrollbar class="scroll-x-container">
  <div class="menu">
    <div class="container">
      <div class="flex_block mid">
        <div class="item" routerLink="./tournaments" routerLinkActive="active">
          <p>Current Tournaments</p>
        </div>
        <div class="item" routerLink="./qualified-players" routerLinkActive="active">
          <p>Qualified Players</p>
        </div>
        <div class="item" routerLink="./highlights" routerLinkActive="active">
          <p>Live Streams</p>
        </div>
      </div>
    </div>
  </div>
</perfect-scrollbar>


<!--<app-reno-cup-tournaments></app-reno-cup-tournaments>-->
<router-outlet></router-outlet>

<!--<app-reno-cup-footer></app-reno-cup-footer>-->
